export const businessSectors = [
  { id: 'restauration', name: 'Restauration & Gastronomie', icon: 'ri-restaurant-line' },
  { id: 'hotellerie', name: 'Hôtellerie & Hébergement', icon: 'ri-hotel-line' },
  { id: 'tourisme', name: 'Tourisme & Voyages', icon: 'ri-plane-line' },
  { id: 'commerce', name: 'Commerce & Distribution', icon: 'ri-store-2-line' },
  { id: 'ecommerce', name: 'E-commerce & Marketplace', icon: 'ri-shopping-cart-line' },
  { id: 'tech', name: 'Technologie & Informatique', icon: 'ri-code-s-slash-line' },
  { id: 'telecom', name: 'Télécommunications', icon: 'ri-signal-tower-line' },
  { id: 'finance', name: 'Finance & Banque', icon: 'ri-bank-line' },
  { id: 'assurance', name: 'Assurance', icon: 'ri-file-shield-line' },
  { id: 'immobilier', name: 'Immobilier', icon: 'ri-home-4-line' },
  { id: 'btp', name: 'Construction & BTP', icon: 'ri-building-2-line' },
  { id: 'architecture', name: 'Architecture & Ingénierie', icon: 'ri-ruler-line' },
  { id: 'industrie', name: 'Industrie & Fabrication', icon: 'ri-settings-3-line' },
  { id: 'automobile', name: 'Automobile & Transport', icon: 'ri-car-line' },
  { id: 'logistique', name: 'Logistique & Livraison', icon: 'ri-truck-line' },
  { id: 'agro', name: 'Agriculture & Agroalimentaire', icon: 'ri-plant-line' },
  { id: 'elevage', name: 'Élevage & Pêche', icon: 'ri-anchor-line' },
  { id: 'energie', name: 'Énergie & Électricité', icon: 'ri-flashlight-line' },
  { id: 'petrole', name: 'Pétrole, Gaz & Mines', icon: 'ri-oil-line' },
  { id: 'sante', name: 'Santé & Pharmaceutique', icon: 'ri-medicine-bottle-line' },
];